import { createAction, handleActions } from "redux-actions";
import { takeLatest } from 'redux-saga/effects';
import createRequestSaga, { createRequestActionTypes } from "./lib/createRequestSaga";
import * as blackListAPI from "../api/blackList";
import { currentPageNumberProps, filterItemProps, GetPayload, PaginationItemProps } from "../types/commons";
import { blackListState, listBlackProps } from "../types/blackList";

const INITIALIZE = 'blackListList/INITIALIZE';
const SET_BLACK_LIST_CURRENT_PAGE_NUMBER = 'blackListList/SET_BLACK_LIST_CURRENT_PAGE_NUMBER' as const;
const SET_BLACK_PAGINATION_ITEM = 'blackListList/SET_BLACK_PAGINATION_ITEM' as const;
const SET_BLACK_FILTER_ITEM = 'blackListList/SET_BLACK_FILTER_ITEM' as const;
const SET_BLACK_INIT_FILTER_ITEM = 'blackListList/SET_BLACK_INIT_FILTER_ITEM' as const;
const SET_BLACK_DETAIL = 'blackListList/SET_BLACK_DETAIL' as const;

//리덕스 모듈에서 API를 사용할 수 있게 추가
const [BLACK_LIST, BLACK_LIST_SUCCESS, BLACK_LIST_FAILURE] = createRequestActionTypes('blackListList/BLACK_LIST');

/* action */
export const initialize = createAction(INITIALIZE);
//호텔 목록 조회 시도
export const listBlackAction = createAction(BLACK_LIST, ({ hotel_id, room_no, offset, limit, pagination }:listBlackProps) => ({
  hotel_id,
  room_no,
  offset,
  limit,
  pagination,
}));
export const setCurrentPageNumberAction = createAction(SET_BLACK_LIST_CURRENT_PAGE_NUMBER, ({currentPageNumber}:currentPageNumberProps) => ({
  currentPageNumber,
}));
export const setPaginationItemAction = createAction(SET_BLACK_PAGINATION_ITEM, ({paginationItem}:PaginationItemProps) => (
  paginationItem
));
export const setFilterItemAction = createAction(SET_BLACK_FILTER_ITEM, (filterItem:filterItemProps) => ({
  filterItem
}));

export const setDetailField = createAction(SET_BLACK_DETAIL, (id:string) => ({
  id
}));
export const setInitFilterItemAction = createAction(SET_BLACK_INIT_FILTER_ITEM);

//사가 생성
const listBlackSaga = createRequestSaga(BLACK_LIST, blackListAPI.listBlackList);

export function* blackListListSaga(){
  yield takeLatest(BLACK_LIST, listBlackSaga);
}

//initialState
const initialState:blackListState = {
  blackListTotal: 0,
  blackListItems: [],
  currentPageNumber: 1,
  paginationItem: {
    offset: 0,
    limit: 50,
  },
  filterItem: {
    room_no: '',
  },
  blackListError: null,
  detailField:{
    id: '',
  }, //detail로 진입 시 저장
};
  
// 페이로드를 가져오기 위한 헬퍼 타입
type Payloads = GetPayload<typeof initialize | typeof listBlackAction | typeof setCurrentPageNumberAction
| typeof setPaginationItemAction | typeof setFilterItemAction | typeof setDetailField | typeof setInitFilterItemAction>;

const blackListList = handleActions<blackListState, Payloads>(
  {
    [INITIALIZE] : state => initialState, // initialState를 넣으면 초기 상태로 바뀜
    // 객실목록 조회 성공
    [BLACK_LIST_SUCCESS] : (state, { payload: {total, items} }) => ({
      ...state,
      blackListTotal: total,
      blackListItems: items,
      blackListError: null,
    }),
    // 객실목록 조회 실패
    [BLACK_LIST_FAILURE] : (state, { payload: error }) => ({
      ...state,
      blackListError: error,
    }),
    // 객실 현재 페이지
    [SET_BLACK_LIST_CURRENT_PAGE_NUMBER] : (state, { payload: {currentPageNumber} }) => ({
      ...state,
      currentPageNumber: currentPageNumber,
    }),
    // 객실 페이지네이션
    [SET_BLACK_PAGINATION_ITEM] : (state, { payload: paginationItem }) => ({
      ...state,
      paginationItem: paginationItem,
    }),
    // 객실 필터
    [SET_BLACK_FILTER_ITEM] : (state, { payload: filter }) => ({
      ...state,
      filterItem: filter.filterItem,
    }),
    // 객실 초기화
    [SET_BLACK_INIT_FILTER_ITEM] : (state) => ({
      ...state,
      filterItem: {
          room_no: '',
      }
    }),
    // detail 접근 시 필드 저장
    [SET_BLACK_DETAIL] : (state, { payload: detailField }) => ({
      ...state,
      detailField: {
          id: detailField.id,
      }
    }),
  },
  initialState,
);

export default blackListList;
